import { Banner } from 'utils/banner/utils';
import { Campaign, getCampaignIdFromMatch } from 'utils/campaign';

import { Requirements } from 'app/routes';

import { setBanners, setBannersCampaign } from 'store/models/banners';

export const BannersPageRequirements: Requirements<{ banners: Banner[]; campaign: Campaign }> = {
    methods: ({ match }) => {
        const campaignId = getCampaignIdFromMatch(match) || '';

        return {
            campaign: {
                url: `/api/v1/campaigns/${campaignId}`,
                cacheable: false,
            },
            banners: {
                url: `/api/v1/campaigns/${campaignId}/banners`,
                cacheable: false,
            },
        };
    },
    resolve: ({ result: { banners, campaign } }) => [setBannersCampaign(campaign), setBanners(banners)],
};
